import { useAdmin, LOGO_FONT_OPTIONS } from "@/context/AdminContext";

export default function LogoFontPicker({ isDark }: { isDark: boolean }) {
  const { logoFontId, setLogoFontId } = useAdmin();
  const headingColor = isDark ? "text-white" : "text-gray-800";
  const subColor = isDark ? "text-gray-400" : "text-gray-500";
  const cardBg = isDark ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200";

  return (
    <div className={`rounded-2xl border p-5 ${cardBg}`}>
      <h3 className={`font-bold text-sm mb-1 ${headingColor}`}>
        <i className="ri-font-size text-pink-400 mr-1.5"></i>
        Logo &amp; Heading Font
      </h3>
      <p className={`text-xs mb-4 ${subColor}`}>
        Choose a font style for the logo and all section headings across the site. Changes apply instantly.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {LOGO_FONT_OPTIONS.map((opt) => {
          const isSelected = logoFontId === opt.id;
          return (
            <button
              key={opt.id}
              onClick={() => setLogoFontId(opt.id)}
              className={`relative flex flex-col items-start gap-1.5 px-4 py-3.5 rounded-xl border-2 cursor-pointer transition-all text-left ${
                isSelected
                  ? "border-pink-500 bg-pink-50"
                  : isDark
                    ? "border-gray-600 bg-gray-700/50 hover:border-gray-500"
                    : "border-gray-200 bg-gray-50 hover:border-pink-300"
              }`}
            >
              {isSelected && (
                <div className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center bg-pink-500 rounded-full">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
              )}
              <span
                className={`text-xl font-bold leading-tight ${isSelected ? "text-pink-700" : isDark ? "text-white" : "text-gray-800"}`}
                style={{ fontFamily: opt.fontFamily, ...opt.style }}
              >
                {opt.preview}
              </span>
              <span className={`text-xs font-medium ${isSelected ? "text-pink-500" : subColor}`}>
                {opt.name}
              </span>
            </button>
          );
        })}
      </div>
      <p className={`text-xs mt-3 ${subColor}`}>
        <i className="ri-information-line mr-1"></i>
        The font applies to the logo in the navbar, footer, and all major section headings.
      </p>
    </div>
  );
}